<section class="dashboard-page">
    <header class="dashboard-header">
        <div>
            <h1 class="dashboard-title">Übersicht</h1>
            <p class="dashboard-subtitle">Kurze Übersicht für {{ clientLabel }}</p>
        </div>
    </header>

    <mat-tab-group class="dashboard-tabs" (selectedTabChange)="onDashboardTabChange($event.index)">
        <mat-tab label="Übersicht">
            <div class="dashboard-tab-content">
                <section class="dashboard-section">
                    <article class="panel">
                        <div class="panel-header">
                            <h2 class="panel-title-clickable link-animated" (click)="openBereitZumImportieren()">Bereit zum Importieren</h2>
                        </div>

                        <div *ngIf="importTierlistenState.loading" class="panel-state">Lade Importlisten...</div>
                        <div *ngIf="!importTierlistenState.loading && importTierlistenState.error" class="panel-state panel-state--error">
                            {{ importTierlistenState.error }}
                        </div>
                        <div
                            *ngIf="!importTierlistenState.loading && !importTierlistenState.error && importTierlisten.length === 0"
                            class="panel-state"
                        >
                            Keine Listen zum Importieren.
                        </div>

                        <ul
                            *ngIf="!importTierlistenState.loading && !importTierlistenState.error && importTierlisten.length > 0"
                            class="list"
                        >
                            <li
                                *ngFor="let tierliste of importTierlisten"
                                class="list-item list-item--clickable"
                                (click)="openImportTierlisteRow(tierliste)"
                            >
                                <div>
                                    <p class="item-title">Tierliste #{{ tierliste.tierliste_id }}</p>
                                    <p class="item-meta">
                                        <span class="item-meta__route">
                                            <span>{{ tierliste.kunden_abgang }}</span>
                                            <ng-container *ngIf="showImportTierlisteRoute(tierliste)">
                                                <mat-icon class="item-meta__arrow" aria-hidden="true">arrow_forward</mat-icon>
                                                <span>{{ getImportTierlisteZielName(tierliste) }}</span>
                                            </ng-container>
                                        </span>
                                        <span class="item-meta__divider">|</span>
                                        <span>{{ tierliste.anzahl_tiere }} Tiere</span>
                                    </p>
                                </div>
                                <div class="item-right">
                                    <span class="item-chip" [ngClass]="getStatusChipClass(tierliste.status_id)">
                                        {{ tierliste.status || getStatusLabel(tierliste.status_id) }}
                                    </span>
                                    <div class="item-menu" (click)="$event.stopPropagation()">
                                        <kiene-letzte-aktionen-tierliste-menu
                                            [tierlisteId]="tierliste.tierliste_id"
                                            [listenstatusId]="tierliste.status_id"
                                            mode="importieren"
                                            (changed)="onImportTierlisteChanged()"
                                        ></kiene-letzte-aktionen-tierliste-menu>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div *ngIf="showMoreImportTierlistenButton" class="panel-footer">
                            <button mat-stroked-button class="more-button" (click)="loadAllImportTierlisten()">Weitere</button>
                        </div>
                    </article>
                </section>

                <section class="dashboard-section dashboard-section--letzte-aktionen">
                    <kiene-letzte-aktionen-panel (refreshRequested)="onLetzteAktionenRefresh()"></kiene-letzte-aktionen-panel>
                </section>
            </div>
        </mat-tab>

        <mat-tab label="Diagramme">
            <section *ngIf="isChartsTabActive" class="dashboard-tab-content" #chartsTabContent>
                <div class="chart-block panel chart-block--all">
                    <div class="chart-stack">
                        <div class="chart-pair-grid">
                            <div class="chart-pair-item">
                                <div class="chart-block__header">
                                    <div>
                                        <h2>Tierbewegungen</h2>
                                        <p class="chart-block__subtitle">Tierbewegungen nach Zeitraum</p>
                                    </div>
                                    <mat-button-toggle-group
                                        [value]="chartGrouping"
                                        (change)="onChartGroupingChange($event.value)"
                                        aria-label="Zeitgruppierung"
                                    >
                                        <mat-button-toggle value="day">Tage</mat-button-toggle>
                                        <mat-button-toggle value="week">Wochen</mat-button-toggle>
                                        <mat-button-toggle value="month">Monate</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>

                                <div class="chart-block__meta">Letzte {{ chartWindowSize }} {{ getChartWindowLabel() }}</div>

                                <div class="chart-series-toggle">
                                    <button
                                        type="button"
                                        class="chart-series-toggle__item"
                                        *ngFor="let series of chartSeriesMeta"
                                        [class.chart-series-toggle__item--active]="isChartSeriesVisible(series.key)"
                                        [class.chart-series-toggle__item--inactive]="!isChartSeriesVisible(series.key)"
                                        (click)="toggleChartSeries(series.key)"
                                    >
                                        <span class="chart-series-toggle__dot" [style.backgroundColor]="series.color"></span>
                                        {{ series.label }}
                                    </button>
                                </div>

                                <google-chart
                                    *ngIf="chartHasData; else noMovementData"
                                    class="chart-block__chart"
                                    [type]="chartType"
                                    [columns]="chartColumns"
                                    [data]="chartData"
                                    [options]="chartOptions"
                                >
                                </google-chart>
                                <ng-template #noMovementData>
                                    <div class="panel-state">Keine Daten gefunden.</div>
                                </ng-template>
                            </div>

                            <div class="chart-pair-item">
                                <div class="chart-block__header">
                                    <div>
                                        <h2>Preise</h2>
                                        <p class="chart-block__subtitle">Summierte Preise je Einstalldatum</p>
                                    </div>
                                    <div class="price-header-actions">
                                        <mat-button-toggle-group
                                            [value]="priceDateFilter"
                                            (change)="setPriceDateFilter($event.value)"
                                            aria-label="Preis Zeitraum"
                                        >
                                            <mat-button-toggle value="month">Monat</mat-button-toggle>
                                            <mat-button-toggle value="90days">90 Tage</mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
                                </div>
                                <div class="chart-block__meta chart-block__meta--placeholder" aria-hidden="true">&nbsp;</div>

                                <div class="chart-series-toggle">
                                    <button
                                        type="button"
                                        class="chart-series-toggle__item"
                                        *ngFor="let series of priceChartSeriesMeta"
                                        [class.chart-series-toggle__item--active]="isPriceChartSeriesVisible(series.key)"
                                        [class.chart-series-toggle__item--inactive]="!isPriceChartSeriesVisible(series.key)"
                                        (click)="togglePriceChartSeries(series.key)"
                                    >
                                        <span class="chart-series-toggle__dot" [style.backgroundColor]="series.color"></span>
                                        {{ series.label }}
                                    </button>
                                </div>

                                <google-chart
                                    *ngIf="priceChartHasData; else noPriceData"
                                    class="chart-block__chart"
                                    [type]="priceChartType"
                                    [columns]="priceChartColumns"
                                    [data]="priceChartData"
                                    [options]="priceChartOptions"
                                >
                                </google-chart>
                                <ng-template #noPriceData>
                                    <div class="panel-state">Keine Daten gefunden.</div>
                                </ng-template>
                            </div>
                        </div>

                        <div class="chart-block__subsection">
                            <div class="chart-block__header">
                                <div>
                                    <h2>Tieralter je Gruppe</h2>
                                    <p class="chart-block__subtitle">
                                        {{
                                            showAllGroupAgeGroups
                                                ? (groupAgeUnit === 'days'
                                                    ? 'Alle sichtbaren Gruppen mit Tieralter in Tagen'
                                                    : 'Alle sichtbaren Gruppen mit Tieralter in Wochen')
                                                : (groupAgeUnit === 'days'
                                                    ? 'Die 5 wichtigsten Gruppen mit Tieralter in Tagen'
                                                    : 'Die 5 wichtigsten Gruppen mit Tieralter in Wochen')
                                        }}
                                    </p>
                                </div>
                                <div class="group-age-header-actions">
                                    <mat-button-toggle-group [value]="groupAgeUnit" (change)="setGroupAgeUnit($event.value)" aria-label="Tieralter Einheit">
                                        <mat-button-toggle value="weeks">Wochen</mat-button-toggle>
                                        <mat-button-toggle value="days">Tage</mat-button-toggle>
                                    </mat-button-toggle-group>
                                    <button mat-stroked-button type="button" (click)="toggleGroupAgeGroupScope()">
                                        {{ showAllGroupAgeGroups ? 'Die 5 wichtigsten Gruppen anzeigen' : 'Alle Gruppen laden' }}
                                    </button>
                                </div>
                            </div>
                            <div class="chart-block__meta chart-block__meta--placeholder" aria-hidden="true">&nbsp;</div>

                            <google-chart
                                *ngIf="groupAgeChartHasData; else noGroupAgeData"
                                class="chart-block__chart"
                                [type]="groupAgeChartType"
                                [columns]="groupAgeChartColumns"
                                [data]="groupAgeChartData"
                                [options]="groupAgeChartOptions"
                            >
                            </google-chart>
                            <ng-template #noGroupAgeData>
                                <div class="panel-state">Keine Daten gefunden.</div>
                            </ng-template>
                        </div>

                        <div class="chart-block__subsection">
                            <div class="chart-block__header">
                                <div>
                                    <h2>Gewichtsverlauf</h2>
                                    <p class="chart-block__subtitle">Tierverlauf von Einstallgewicht zu Abganggewicht je Gruppe</p>
                                </div>
                                <div class="price-header-actions">
                                    <mat-button-toggle-group
                                        [value]="weightDateFilter"
                                        (change)="setWeightDateFilter($event.value)"
                                        aria-label="Gewicht Zeitraum"
                                    >
                                        <mat-button-toggle value="month">Monat</mat-button-toggle>
                                        <mat-button-toggle value="90days">90 Tage</mat-button-toggle>
                                        <mat-button-toggle value="all">Gesamter Zeitraum</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                            </div>
                            <div class="chart-block__meta chart-block__meta--placeholder" aria-hidden="true">&nbsp;</div>

                            <google-chart
                                *ngIf="weightTimelineChartHasData; else noWeightTimelineData"
                                class="chart-block__chart chart-block__chart--timeline"
                                [type]="weightTimelineChartType"
                                [columns]="weightTimelineChartColumns"
                                [data]="weightTimelineChartData"
                                [options]="weightTimelineChartOptions"
                            >
                            </google-chart>
                            <ng-template #noWeightTimelineData>
                                <div class="panel-state">Keine Daten gefunden.</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </section>
        </mat-tab>
    </mat-tab-group>
</section>
